import React from 'react';
import { Box } from '@mui/material';
import edjobster09 from '../assets/images/edjobster09.png';

const Loader = () => (
  <Box
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      bgcolor: '#fff',
      zIndex: 2000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    }}
  >
    <img src={edjobster09} alt="Edjobster Loader" style={{ width: 300, height: 100 }} /> 
 
    <Box
      sx={{
        mt: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.2,
        '@keyframes bounce': {
          '0%, 80%, 100%': { transform: 'scale(0)' },
          '40%': { transform: 'scale(1)' },
        },
      }}
    >
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          animation: 'bounce 1.4s infinite ease-in-out both',
          animationDelay: '0s',
        }}
      />
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          animation: 'bounce 1.4s infinite ease-in-out both',
          animationDelay: '0.2s',
        }}
      />
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          animation: 'bounce 1.4s infinite ease-in-out both',
          animationDelay: '0.4s',
        }}
      />
    </Box>
  </Box>
);

export default Loader;